<template>
    <Popup ref="popup" :animation="'scale'" :shadowOpacity="0.7">
        <div class="info-cont" :style="landscapeScale < 1 ? { transform: `scale(${landscapeScale})` } : {}">
            <img class="info-bg" :src="_global.isMobile
                ? _global.assetsRoot + '/mobile/web_phone_pop_userid_bg_' + _i18n.locale + '.png'
                : _global.assetsRoot + '/desktop/web_pc_pop_userid_bg_' + _i18n.locale + '.png'" />
            <div class="content">
                <div class="close t-r v-m">
                    <img class="v-m btn" :src="_global.assetsRoot + '/common/pop_btn_close.png'" @click.stop="close" />
                </div>
                <div class="buttons-section t-c">
                    <div class="btn retry-btn v-m" @click.stop="close">
                        <span class="beba v-m">{{ $t("message.tryAgain") }}</span>
                    </div>
                </div>
            </div>
        </div>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue'

export default {
    props: {
        // Can be used to display different failure reasons
    },
    data() {
        return {
            failureReason: '',
            landscapeScale: 1
        }
    },
    methods: {
        show(reason = null) {
            this.failureReason = reason || this.$t("message.infoReason");
            if (window.innerWidth > window.innerHeight) {
                this.landscapeScale = Math.min((window.innerHeight * 0.85) / (window.innerWidth * 0.90), 1);
            } else {
                this.landscapeScale = 1;
            }
            this.$refs.popup.show();
        },
        close() {
            this.$refs.popup.hide();
            this.$emit("onclose");
        }
    },
    components: { Popup }
}
</script>

<style lang="scss">
@import "../../assets/css/variables.scss";

.info-cont {
    position: relative;
    width: 75vw;
    aspect-ratio: 1;
    margin: 0 auto;
    transform-origin: center center;

    .info-bg {
        width: 100%;
    }

    .close {
        position: absolute;
        top: -3vw;
        right: 0;
        z-index: 10;
        width: 9vw;
        height: 9vw;

        img {
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
    }

    .content {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 4vw;

        .buttons-section {
            position: absolute;
            bottom: 0vw;
            left: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: center;

            .btn {
                display: inline-block;
                height: 10vw;
                width: 35vw;

                span {
                    color: #FFF;
                }
            }

            .retry-btn {
                background: url($assetRoot + "/common/btn_buy.png") center no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
                color: #FFFFFF;
                font-weight: bold;
                font-size: 7vw;
                text-shadow:
                    -1px -1px 0 #000000,
                    0px -1px 0 #000000,
                    1px -1px 0 #000000,
                    -1px  0px 0 #000000,
                    1px  0px 0 #000000,
                    -1px  1px 0 #000000,
                    0px  1px 0 #000000,
                    1px  1px 0 #000000;
            }
        }
    }
}

.mobile{
    .info-cont{
        .content{
            .buttons-section{
                bottom: 6vw;

                .retry-btn{
                    line-height: 9vw;
                }
            }
        }
    }
}

/* .mobile override removed — use vw-based responsive base styles above */
</style>



// WEBPACK FOOTER //
// src/components/popup/Info.vue